// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__Hw8QQ","name":"ConsentHeader_name__2QxCT","birthday":"ConsentHeader_birthday__KnoyJ","skeleton":"ConsentHeader_skeleton__3hvng"};